import React, { useState, useEffect, useRef } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

function ScrollableBarChartGraph({ data }) {
    const [page, setPage] = useState(0);
    const [chartWidth, setChartWidth] = useState(800);
    const containerRef = useRef(null);

    console.log("Datos recibidos para BarChart:", data);

    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                const width = containerRef.current.offsetWidth;
                setChartWidth(width - 100);
            }
        };

        updateWidth();
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    if (!data || data.length === 0) {
        return null;
    }

    const itemsPerPage = 5;
    const totalPages = Math.ceil(data.length / itemsPerPage);
    const start = page * itemsPerPage;
    const end = start + itemsPerPage;
    const pageData = data.slice(start, end);

    const hasEliminacion = data.some(
        (item) =>
            item["Eliminación"] !== undefined && item["Eliminación"] !== null
    );

    const barSize = !hasEliminacion ? 24 : 32;

    return (
        <div
            ref={containerRef}
            style={{ position: "relative", width: "100%", height: "420px" }}
        >
            {totalPages > 1 && (
                <div
                    style={{
                        textAlign: "center",
                        fontSize: "13px",
                        color: "#666",
                        marginBottom: "12px",
                    }}
                >
                    Página {page + 1} de {totalPages}
                </div>
            )}

            {page > 0 && (
                <button
                    onClick={() => setPage(page - 1)}
                    className="carousel-btn carousel-btn--left"
                >
                    <FiChevronLeft size={20} />
                </button>
            )}

            {page < totalPages - 1 && (
                <button
                    onClick={() => setPage(page + 1)}
                    className="carousel-btn carousel-btn--right"
                >
                    <FiChevronRight size={20} />
                </button>
            )}

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                }}
            >
                <BarChart
                    width={chartWidth}
                    height={400}
                    data={pageData}
                    margin={{ top: 20, right: 30, left: 40, bottom: 5 }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis
                        dataKey="name"
                        tick={{ fontSize: 11, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <YAxis
                        tick={{ fontSize: 11, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                        width={70}
                    />
                    <Tooltip
                        contentStyle={{
                            fontSize: "12px",
                            borderRadius: "8px",
                            padding: "10px 12px",
                        }}
                        labelStyle={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "#333",
                        }}
                        itemStyle={{
                            fontSize: "12px",
                            color: "#333",
                        }}
                    />
                    <Legend
                        wrapperStyle={{
                            fontSize: "14px",
                            color: "#666",
                            paddingTop: "10px",
                        }}
                    />
                    {hasEliminacion && (
                        <Bar
                            dataKey="Eliminación"
                            fill="#0b6775"
                            radius={[4, 4, 0, 0]}
                            maxBarSize={barSize}
                        />
                    )}

                    <Bar
                        dataKey="Valorización"
                        fill="#5599a3"
                        radius={[4, 4, 0, 0]}
                        maxBarSize={barSize}
                    />
                </BarChart>
            </div>
        </div>
    );
}

export default ScrollableBarChartGraph;
